import React from 'react';
import { Input } from 'antd';

const InputComponent = (props) => {
  const { onChange, ...rest } = props;

  const handleChange = (e) => {
    const value = e.target ? e.target.value : e;
    if (typeof onChange === 'function') {
      onChange(value);
    }
  };

  return (
    <Input
      maxLength={1500}
      {...rest}
      onChange={handleChange}
    />
  );
};

export default InputComponent;
